import * as React from "react"
import { useEffect } from "react"
import { batch, useSignal } from "@preact/signals-react"
import { Box } from "@mui/material"
import { SwitchSeeker } from "@ui-seeker/core"

import { useAdminSkuTable } from "../../@hooks"


export default function validatedColumn() {
    return [{
        name: "validated", label: "Validated",
        options: {
            display: "excluded",
            customBodyRowRender: v => v ? "Yes" : "No"
        }
    }, {
        name: "validated", label: "Validated",
        options: {
            filter: false,
            customBodyRowRenderLite: (value, rowData) => <Box display="flex" justifyContent="center">
                <ValidatedCell
                    validated={value}
                    rowData={rowData}
                />
            </Box>
        }
    }]
}

const ValidatedCell = ({ validated, rowData }) => {
    const localStatus = useSignal(validated)
    const { handleValidated } = useAdminSkuTable(rowData.skuID)

    useEffect(() => {
        localStatus.value = validated
    }, [validated])

    return <SwitchSeeker
        formControlProps={{sx: { margin: '0 auto' }}}
        checked={localStatus.value}
        onChange={e => batch(() => {
            const newValue = e.target.checked
            localStatus.value = newValue
            handleValidated(newValue, () => localStatus.value = !newValue)
        })}
    />
}